import { render, staticRenderFns } from "./AppMail.vue?vue&type=template&id=2150ea95&"
import script from "./AppMail.vue?vue&type=script&lang=js&"
export * from "./AppMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports